module.exports = __webpack_public_path__ + "media/images/emblems/Kerns-coat_of_arms-ae31262e96dbaeabdae59aea0fdcc5b1.svg";